<template>
  <svg id="icon-plus" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-351.5-12.5h554v512h-554z"/>
      <path d="M14.583 9.083a.917.917 0 1 1 0 1.834h-3.666v3.666a.917.917 0 1 1-1.834 0v-3.666H5.417a.917.917 0 0 1 0-1.834h3.666V5.417a.917.917 0 0 1 1.834 0v3.666h3.666z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
